module.exports = __webpack_public_path__ + "img/10.c59d06d0.png";